import React, { useState } from 'react';
import { ButtonPrimary, spacer16 } from '@spotify-internal/encore-web';
import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { FeedbackStatus, showSurveyOptionEnum } from 'utils/remote-config/properties';

import HelpfulPoll from '../HelpfulPoll';
import ThanksMessage from '../ThanksMessage';
import ReasonSelector from '../ReasonSelector';
import { IsHelpfulAnswerEnum } from '../../hooks/useIsHelpfulAnswer';
import { ReasonKey } from '../../hooks/useSubmitReason';

// import { useTranslation } from 'providers/translations/TranslationProvider';

interface FeedbackWidgetContentProps {
  isHelpfulAnswered?: IsHelpfulAnswerEnum;
  answerIfIsHelpful: (answer: IsHelpfulAnswerEnum) => void;
  isSubmittedReason: boolean;
  submitReason: (reason: ReasonKey) => void;
  trackMessageUsLink: () => void;
}
const FeedbackWidgetContent = ({
  isHelpfulAnswered,
  answerIfIsHelpful,
  isSubmittedReason,
  submitReason,
  trackMessageUsLink,
}: FeedbackWidgetContentProps) => {
  // const { t } = useTranslation();
  const [reason, setReason] = useState<ReasonKey>();

  // TODO: We are experiment if we improve the UX removing this step in the Treatment
  const showSurveyOption =
    useProperty(showSurveyOptionEnum, { loadingValue: FeedbackStatus.SHOW_SURVEY }) === FeedbackStatus.SHOW_SURVEY;

  const showThanksMessage =
    isSubmittedReason || isHelpfulAnswered === IsHelpfulAnswerEnum.yes || (!showSurveyOption && isHelpfulAnswered);
  const showReasonSelector = isHelpfulAnswered === IsHelpfulAnswerEnum.no && showSurveyOption;

  // last step - tanks message
  if (showThanksMessage) {
    return <ThanksMessage answered={isHelpfulAnswered} trackMessageUsLink={trackMessageUsLink} />;
  }

  // second step - survey option
  if (showReasonSelector) {
    return (
      <form
        onSubmit={e => {
          e.preventDefault();
          if (reason) submitReason(reason);
        }}
      >
        <ReasonSelector selected={reason} onSelect={setReason} />
        <ButtonPrimary type="submit" buttonSize="sm" disabled={!reason} css={{ marginTop: spacer16 }}>
          {/* {t('feedback_submit_reason')}*/}
          Submit
        </ButtonPrimary>
      </form>
    );
  }

  // first step - yes/no question
  return (
    <HelpfulPoll
      onYesClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.yes)}
      onNoClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.no)}
    />
  );
};

export default FeedbackWidgetContent;
